module.exports = __webpack_public_path__ + "media/images/phone/story-script_tap-bg-77f63321d7cefe648ca520bc88c50ac2.png";